import { api } from '@api'
import { UpdateTruckData } from '@types'

interface UpdateTruckResponse {
  message: string
}

const updateTruck = async (truckId: number, data: UpdateTruckData) => {
  const truckData = {
    truck: {
      description: data.description,
      equipmentType: data.equipmentType,
      straightTruck: data.straightTruck ?? false,
      disabled: data.disabled,
    },
  }
  const response = await api.put<UpdateTruckResponse>(`/trucks/${truckId}`, truckData)

  return response.data.message
}

export const TrucksApi = {
  updateTruck,
}
